<!-- Breadcrumb-Navigation (Tailwind CSS classes für Poseidon-ähnliches Styling) -->
<nav class="layout-breadcrumb flex items-center space-x-2">
  
  <!-- Breadcrumbs -->
  <ol class="flex items-center flex-wrap space-x-1">
    <ng-container *ngFor="let crumb of breadcrumbs$ | async; let last = last">
      <li class="flex items-center">
        <!-- Verlinkter Breadcrumb (nicht letzter) -->
        <a *ngIf="!last" [routerLink]="crumb.url" class="font-medium text-surface-950 dark:text-surface-0 text-xl">
          {{ crumb.label }}
        </a>
        <!-- Letzter Breadcrumb (aktuelle Seite, nicht verlinkt) -->
        <span *ngIf="last" class="font-medium text-surface-950 dark:text-surface-0 text-xl">
          {{ crumb.label }}
        </span>
      </li>
      <!-- Separator zwischen Breadcrumbs -->
      <li *ngIf="!last" class="font-medium text-surface-950 dark:text-surface-0 text-xl">/</li>
    </ng-container>
  </ol>
</nav>
